export const FEEDBACK_TYPES = {
    DONT_HAVE_LINKEDIN: 'DONT_HAVE_LINKEDIN',
    DONT_WANT_TO_SHARE_LINKEDIN: 'DONT_WANT_TO_SHARE_LINKEDIN'
};
